import React from 'react'
import { useIntl } from 'react-intl'
import { Heading2, Page, Text } from '../../components/layout'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { messages } from './messages'

export const SearchPage: React.FunctionComponent = () => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  return (
    <Page>
      <Heading2>{formatMessage(messages.heading)}</Heading2>
      <Text>{formatMessage(messages.description)}</Text>
    </Page>
  )
}
